import { render, staticRenderFns } from "./levelsServices.vue?vue&type=template&id=56fc4f46&scoped=true&"
import script from "./levelsServices.vue?vue&type=script&lang=js&"
export * from "./levelsServices.vue?vue&type=script&lang=js&"
import style0 from "./levelsServices.vue?vue&type=style&index=0&id=56fc4f46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc4f46",
  null
  
)

export default component.exports